import PropTypes from 'prop-types';
import React from 'react';
import diff from 'object-diff';
import PropertyOverview from './PropertyOverview';
import PropertyOverviewForm from './PropertyOverviewForm';

class PropertyOverviewContainer extends React.Component {
  constructor() {
    super();
    this.state = {
      isEditing: false,
    };
    this.handleEdit = this.handleEdit.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }
  handleEdit() {
    this.setState({ isEditing: true });
  }
  handleClose() {
    this.setState({ isEditing: false });
  }
  handleSubmit(values) {
    console.log('handle submit...', values);
    if (this.props.isAddHotel) {
      this.props.addHotel(values);
    } else {
      //const changedValues = diff(this.props.hotel, values);
      values.isPosition = true
      this.props.editHotel(this.props.hotel.id, values);
    }
    this.handleClose();
  }
  render() {
    if (this.state.isEditing || this.props.isAddHotel) {
      return (
        <PropertyOverviewForm
          brands={this.props.brands}
          onSubmit={this.handleSubmit}
          handleEdit={this.handleEdit}
          initialValues={this.props.hotel}
          handleClose={this.handleClose}
        />);
    }
    return (
      <PropertyOverview {...this.props} handleEdit={this.handleEdit} />
    );
  }
}
PropertyOverviewContainer.propTypes = {
  hotel: PropTypes.object.isRequired,
  editHotel: PropTypes.func.isRequired,
};

export default PropertyOverviewContainer;



// WEBPACK FOOTER //
// src/routes/hotels/components/PropertyOverviewContainer.js